import { render } from "./BaseLoader.vue?vue&type=template&id=2846c752"
import script from "./BaseLoader.vue?vue&type=script&lang=js"
export * from "./BaseLoader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__